export const MOBILE_SHELL_SPRING_TRANSITION = {
	type: 'spring',
	stiffness: 420,
	damping: 42,
	mass: 0.8,
	restDelta: 0.5,
} as const
